import { h } from 'preact'
import styled from 'styled-components'
import arrow from './arrow.svg'

const ArrowCheckbox = styled.input`
  width: 40px;
  height: 40px;
  overflow: hidden;
  position: absolute;
  vertical-align: middle;
  margin: 0px;
  background: transparent;
  opacity: 0;
  outline: none;

  + div {
    vertical-align: middle;
    display: inline-block;
    width: 40px;
    height: 40px;
    border: 1px solid transparent;
    position: absolute;
    background: #353f4b;
    + div {
      width: 40px;
      height: 40px;
      background: url(${arrow}) center no-repeat;
      transform: ${props =>
        props.checked ? 'rotate(0deg)' : 'rotate(180deg)'};
      transition: transform 0.5s ease-in-out;
    }
  }
  :focus + div {
    border: 1px solid ${props => (props.error ? '#fa4624' : '#4d90fe')};
  }
`

const Container = styled.div`
  width: 40px;
  height: 40px;
  display: inline-block;
  margin-left: 20px;
`

export default props => (
  <Container>
    <ArrowCheckbox {...props} checked={props.checked} />
    <div />
    <div />
  </Container>
)



// WEBPACK FOOTER //
// ./components/atoms/checkbox/arrowCheckbox.js